import { useRouter } from 'next/router';

const translation = {
  fr: {
    brand: { label: 'Marque', unite: false, skipTranslation: true },
    bodyType: { label: 'Type', unite: false, skipTranslation: true },
    model: { label: 'Modèle', unite: false, skipTranslation: true },
    year: { label: 'Année', unite: false, skipTranslation: true },
    energy: { label: 'Carburant', unite: false, skipTranslation: false },
    gearcase: {
      label: 'Boîte de vitesse',
      unite: false,
      skipTranslation: false,
    },
    power: { label: 'Puissance', unite: 'ch', skipTranslation: true },
    km: { label: 'Kilométrage', unite: 'km', skipTranslation: true },
    engine: { label: 'Cylindrée', unite: 'cm3', skipTranslation: true },
    hour_driving: {
      label: 'Heures de conduite',
      unite: 'h',
      skipTranslation: true,
    },
    pointure: { label: 'Pointure', unite: false, skipTranslation: false },
    size: { label: 'Taille', unite: false, skipTranslation: false },
    rooms: { label: 'Nombre de pièces', unite: false, skipTranslation: false },
    surface: { label: 'Surface ', unite: 'm²', skipTranslation: true },
    meuble_not_meuble: {
      label: 'Meublé / Non meublé',
      unite: false,
      skipTranslation: false,
    },
    type: { label: 'Type', unite: false, skipTranslation: false },
    experience: { label: 'Expérience', unite: false, skipTranslation: false },
    job: { label: 'Fonction', unite: false, skipTranslation: false },
  },
  bi: {
    brand: { label: 'Brand', unite: false, skipTranslation: true },
    bodyType: { label: 'Type', unite: false, skipTranslation: true },
    model: { label: 'Model', unite: false, skipTranslation: true },
    year: { label: 'Yia', unite: false, skipTranslation: true },
    energy: { label: 'Fuel', unite: false, skipTranslation: false },
    gearcase: { label: 'Gear box', unite: false, skipTranslation: false },
    power: { label: 'Hos Pawa', unite: 'ch', skipTranslation: true },
    km: { label: 'Mileage', unite: 'km', skipTranslation: true },
    engine: { label: 'Cubic Capacity', unite: 'cm3', skipTranslation: true },
    hour_driving: {
      label: 'Taem blo draev',
      unite: 'h',
      skipTranslation: true,
    },
    pointure: { label: 'Shus Sais', unite: false, skipTranslation: false },
    size: { label: 'Shus', unite: false, skipTranslation: false },
    rooms: { label: 'Number of rooms', unite: false, skipTranslation: false },
    surface: { label: 'Lo top ', unite: 'm²', skipTranslation: true },
    meuble_not_meuble: {
      label: 'Farnish / Eno farnish',
      unite: false,
      skipTranslation: false,
    },
    type: { label: 'Type', unite: false, skipTranslation: false },
    experience: { label: 'Experiens', unite: false, skipTranslation: false },
    job: { label: 'Function', unite: false, skipTranslation: false },
  },
  en: {
    brand: { label: 'Brand', unite: false, skipTranslation: true },
    bodyType: { label: 'Type', unite: false, skipTranslation: true },
    model: { label: 'Model', unite: false, skipTranslation: true },
    year: { label: 'Year', unite: false, skipTranslation: true },
    energy: { label: 'Fuel', unite: false, skipTranslation: false },
    gearcase: { label: 'Gear box', unite: false, skipTranslation: false },
    power: { label: 'Horse Power', unite: 'ch', skipTranslation: true },
    km: { label: 'Mileage', unite: 'km', skipTranslation: true },
    engine: { label: 'Cubic Capacity', unite: 'cm3', skipTranslation: true },
    hour_driving: { label: 'Driving Times', unite: 'h', skipTranslation: true },
    pointure: { label: 'Shoes Size', unite: false, skipTranslation: false },
    size: { label: 'Size', unite: false, skipTranslation: false },
    rooms: { label: 'Number of rooms', unite: false, skipTranslation: false },
    surface: { label: 'Surface ', unite: 'm²', skipTranslation: true },
    meuble_not_meuble: {
      label: 'Furnished / Not furnished',
      unite: false,
      skipTranslation: false,
    },
    type: { label: 'Type', unite: false, skipTranslation: false },
    experience: { label: 'Experience', unite: false, skipTranslation: false },
    job: { label: 'Function', unite: false, skipTranslation: false },
  },
};

const categories = () => {
  const { locale } = useRouter();

  return translation.hasOwnProperty(locale) ? translation[locale] : [];
};

export default categories;
